import React, { useState, Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { H3_TITLE, QUANTITY } from '@Apis/constants';
import { Helmet } from 'react-helmet';
import H3Text from '@Uilib/h3Text';
import { notification, Checkbox } from 'antd';
import dayjs from 'dayjs';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { v4 as uuidv4 } from 'uuid';
import PurchaseOrderActions from '@Actions/purchaseOrderActions';
import SoActions from '@Actions/sales/soActions';
import TenantActions from '@Actions/tenantActions';
import InvoiceActions from '@Actions/invoiceActions';
import ReturnLines from './ReturnLines';
import './style.scss';

function RefundForm({
  selectedLocationFulfillment, soMapping,
  callback, match, getInvoiceByIdLoading, getReturnFulfillmentLoading,
  createRefund, selectedReturn, shopifyReturns, selectedSO, createRefundLoading,

}) {
  const [shippingAmount, setShippingAmount] = useState('');
  const [transitionAmount, setTransitionAmount] = useState('');
  const [tenantDepartmentId, setTenantDepartmentId] = useState('');
  const [notifyCustomer, setNotifyCustomer] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [selectedReturnData, setSelectedReturnData] = useState({});
  const [data, setData] = useState([]);

  const isCOD = !['paid', 'partially paid'].includes(selectedSO?.shopify_payment_status);

  useEffect(() => {
    if (shopifyReturns) {
      const returns = shopifyReturns?.data?.returns?.filter(
        (item) => item.id === selectedReturn?.rfId,
      );
      setSelectedReturnData(returns);
      const returnLines = returns?.map((item) => item?.return_lines);
      const rawData = returnLines.flat(1);

      const filteredData = rawData?.map((item) => {
        const parentKey = uuidv4();
        const temp = {
          key: parentKey,
          product_sku_name: item?.so_line_object?.product_sku_name,
          product_sku_info: item?.so_line_object?.product_sku_info,
          shopify_fulfillment_line_item_id: item?.shopify_fulfillment_line_item_id,
          return_line_item_id: item?.id,
          location_id: item.shopify_location_id,
          restock: true,
          line_item_id: item?.fulfillmentLineItem?.lineItem.id,
          product_batches: item?.fulfillment_line_info?.product_batches || [],
          selectedBatch: item?.fulfillment_line_info?.product_batches[0],
          ordered_quantity: item?.max_refund_quantity,
          quantity: 0,
          customer_note: '',
          tax_info: item?.so_line_object?.tax_info,
          uom_info: item?.so_line_object?.uom_info,
          offer_price: item?.so_line_object?.offer_price,
          nextBatchCode: `${item.so_line_object?.product_sku_info?.internal_sku_code}/${dayjs().format('DDMMYY')}/${item.so_line_object?.product_sku_info?.product_batch_counter}`,
          bundle_products: item?.bundle_products?.map((bundleItem) => ({
            ...bundleItem,
            parentKey,
            key: uuidv4(),
            unitPrice: QUANTITY(bundleItem?.unit_price),
            uom_info: bundleItem?.product_sku_info?.uom_info,
            product_sku_name: bundleItem?.product_sku_info?.product_sku_name,
            so_quantity: bundleItem?.quantity,
            expiry_days: bundleItem?.product_sku_info?.expiry_days,
            restock: true,
            product_sku_info: bundleItem?.product_sku_info,
            product_batches: bundleItem?.available_batches || [],
            nextBatchCode: `${bundleItem?.product_sku_info?.internal_sku_code}/${dayjs().format('DDMMYY')}/${bundleItem?.product_sku_info?.product_batch_counter}`,
          })),
        };
        return temp;
      });
      setData(filteredData);
    }
  }, [shopifyReturns]);

  const handleDelete = (key) => {
    if (data?.length === 1) {
      notification.error({
        message: 'Order line must have atleast one line',
        placement: 'top',
        duration: 4,
      });
    } else {
      const copyData = data.filter((item) => item.key !== key);
      setData(copyData);
    }
  };


  const handleRefundAmount = () => {
    // const copyData = data?.map((item) => ({
    //   ...item,
    //   quantity: 0,
    // }));
    // setData(copyData);
  };

  const handleQuantityChange = (dataProp) => {
    if (!isCOD) {
      let total = 0;

      for (let i = 0; i < dataProp?.length; i++) {
        total += dataProp[i].quantity * dataProp[i]?.offer_price * (1 + (dataProp[i]?.tax_info?.tax_value) / 100);
      }
      setTransitionAmount(total);
    } else {
      setTransitionAmount(0);
    }
  };

  const isDataValid = () => {
    let isDataValidValue = true;
    for (let i = 0; i < data?.length; i++) {
      if (Number(data[i].quantity) <= 0 || Number(data[i].quantity) > Number(data[i].ordered_quantity)) {
        isDataValidValue = false;
      }
      if (data[i]?.bundle_products?.length) {
        const bundleProducts = data[i]?.bundle_products;
        for (let j = 0; j < bundleProducts?.length; j++) {
          if (!bundleProducts[j]?.selectedBatch) {
            isDataValidValue = false;
          }
        }
      }
    }
    return isDataValidValue;
  };

  const fulfillOrder = () => {
    setFormSubmitted(true);

    const refundLines = [];

    if (isDataValid()) {
      for (let i = 0; i < data?.length; i++) {
        const refundLine = {
          return_line_item_id: data[i]?.return_line_item_id,
          quantity: data[i]?.quantity,
          location_id: data[i]?.location_id,
          restock: data[i]?.restock,
          line_item_id: data[i]?.line_item_id,
          product_batch: [data[i]?.selectedBatch]?.map((item) => ({
            ...item,
            quantity: data[i]?.quantity,
            uom_id: data[i]?.uom_info?.[0]?.uom_id,
            tenant_product_id: data[i]?.tenant_product_id,
          })),
          bundle_products: data[i]?.bundle_products?.map((item) => ({
            quantity: Number(data[i]?.quantity) * (Number(item?.quantity) / Number(data[i]?.ordered_quantity)),
            restock: item?.restock,
            product_sku_id: item.product_sku_info.product_sku_id,
            product_batch: [item?.selectedBatch]?.map((batchItem) => ({
              ...batchItem,
              quantity: Number(data[i]?.quantity) * (Number(item?.quantity) / Number(data[i]?.ordered_quantity)),
              uom_id: item?.uom_id,
              tenant_product_id: item?.tenant_product_id,
            })),
          })),
        };
        refundLines.push(refundLine);
      }

      const payload = {
        notify_customer: !!notifyCustomer,
        shop_name: shopifyReturns?.data?.shop_name,
        return_id: selectedReturnData?.[0]?.id,
        order_id: selectedSO?.order_id,
        transaction: {
          amount: transitionAmount || 0,
          gateway: shopifyReturns?.data?.transactions[0]?.gateway,
          kind: 'REFUND',
          orderId: shopifyReturns?.data?.transactions[0]?.orderId,
          parentId: shopifyReturns?.data?.transactions[0]?.id,
        },
        shipping_transaction: {
          amount: shippingAmount || 0,
          fullRefund: false,
        },
        shopify_order_id: selectedSO?.shopify_order_id,
        refund_lines: refundLines,
      };
      createRefund(payload, () => {
        callback();
      });
    }
  };


  const getDataSource = (dataValue) => {
    if (dataValue) {
      const newData = JSON.parse(JSON.stringify(dataValue));
      return newData;
    }
    return [];
  };

  const { orderId } = match.params;

  return (
    <Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{H3_TITLE}</title>
      </Helmet>
      {getInvoiceByIdLoading ? (
        <div className="fulfill__loading__wrapper">
          {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
            <div key={item} className="fulfill__loading__wrapper-row">
              <div className="fulfill__loading__wrapper-row__label loadingBlock" />
              <div className="fulfill__loading__wrapper-row__value loadingBlock" />
            </div>
          ))}
          <div className="fulfill__loading__wrapper-table loadingBlock" />
          <div className="fulfill__loading__wrapper-details loadingBlock" />
        </div>
      )
        : (
          <div className={match.url.includes('/sales-order') ? 'fulfill__wrapper fulfill-component' : 'fulfill__wrapper fulfill-page'}>
            <div className="ant-row">
              {/* <div className="ant-col-md-18">
                <div className="fulfill__input-row">
                  <H3Text text="SO#" className="fulfill__input-row__label" />
                  <div style={{ marginTop: '5px', fontSize: '13px', fontWeight: '500' }}>
                    {orderId}
                  </div>
                </div>
              </div>
              <div className="ant-col-md-6" />
              <div className="ant-col-md-18">
                <div className="fulfill__input-row">
                  <H3Text text="Shopify Order#" className="fulfill__input-row__label" />
                  <div style={{ marginTop: '5px', fontSize: '13px', fontWeight: '500' }}>
                    { selectedSO?.shopify_order_id || ''}
                  </div>
                </div>
              </div>
              <div className="ant-col-md-6" /> */}

              <div className="ant-col-md-12">
                <div className="fulfill__input-row">
                  <H3Text text="Refund Amount" className="fulfill__input-row__label" />
                  <H3FormInput
                    name="track number"
                    type="text"
                    containerClassName="orgInputContainer fulfill__input-row__input"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput input"
                    placeholder=""
                    onChange={(e) => {
                      handleRefundAmount();
                      setTransitionAmount(e.target.value);
                    }}
                    value={transitionAmount}
                    disabled={getReturnFulfillmentLoading || createRefundLoading}
                  />
                </div>
              </div>
              <div className="ant-col-md-12" />
              <div className="ant-col-md-12">
                <div className="fulfill__input-row">
                  <H3Text text="Shipment Amount" className="fulfill__input-row__label" />
                  <H3FormInput
                    name="track company"
                    type="text"
                    containerClassName="orgInputContainer fulfill__input-row__input"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput input"
                    placeholder=""
                    onChange={(e) => setShippingAmount(e.target.value)}
                    value={shippingAmount}
                    disabled={getReturnFulfillmentLoading || createRefundLoading}
                    subscript={shippingAmount}
                  />
                </div>
              </div>
              <div className="ant-col-md-12" />

              <div className="ant-col-md-18">
                <div className="fulfill__input-row">
                  <H3Text text="Notify customer" className="fulfill__input-row__label" />
                  <div style={{ marginTop: '5px' }}>
                    <Checkbox
                      disabled={getReturnFulfillmentLoading || createRefundLoading}
                      checked={notifyCustomer}
                      onChange={(event) => {
                        setNotifyCustomer(event.target.checked);
                      }}
                    />
                    <span style={{ fontWeight: '500', fontSize: '12px', marginLeft: '5px' }}>
                      Send shipment details to your customer now
                    </span>
                  </div>
                </div>
              </div>
              <div className="ant-col-md-6" />
            </div>
            <div className="fulfill__lines-wrapper">
              <ReturnLines
                handleDelete={handleDelete}
                data={getDataSource(data)}
                handleQuantityChange={handleQuantityChange}
                updateData={(updatedData) => setData(updatedData)}
                formSubmitted={formSubmitted}
                loading={getReturnFulfillmentLoading || createRefundLoading}
                tenantDepartmentId={tenantDepartmentId}
                selectedLocationFulfillment={selectedLocationFulfillment}
                soMapping={soMapping}
                isCOD={isCOD}
              />
            </div>
          </div>
        )}
      <div className="fulfill__footer">
        <H3Button
          text="Save and Issue"
          buttonType={defaultButtonTypes.BLUE_ROUNDED}
          customClass="fulfill__footer-submit"
          onClick={() => {
            fulfillOrder();
          }}
          isLoading={getReturnFulfillmentLoading || createRefundLoading}
          disabled={getReturnFulfillmentLoading || createRefundLoading}
        />
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  SellerReducers, UserReducers, ProductReducers, SOReducers, TenantReducers, InvoiceReducers,
}) => ({
  sellers: SellerReducers.sellers,
  products: ProductReducers.products,
  tenantsConfiguration: TenantReducers.tenantsConfiguration,
  user: UserReducers.user,
  selectedInvoice: InvoiceReducers.selectedInvoice,
  getReturnFulfillmentLoading: SOReducers.getReturnFulfillmentLoading,
  returnFulfillments: SOReducers.returnFulfillments,
  shopifyReturns: SOReducers.shopifyReturns,
  selectedSO: SOReducers.selectedSO,
  createRefundLoading: SOReducers.createRefundLoading,
});

const mapDispatchToProps = (dispatch) => ({
  updatePoStatus: (payload, callback) => dispatch(PurchaseOrderActions.updatePoStatus(payload, callback)),
  getTenantsConfiguration: (tenantId, callback) => dispatch(TenantActions.getTenantsConfiguration(tenantId, callback)),
  getInvoiceById: (tenantId, invoiceId) => dispatch(InvoiceActions.getInvoiceById(tenantId, invoiceId)),
  updateInvoice: (payload, callback) => dispatch(InvoiceActions.updateInvoice(payload, callback)),
  fulfillUnfulfilledOrder: (payload, callback) => dispatch(SoActions.fulfillUnfulfilledOrder(payload, callback)),
  getReturnFulfillment: (orderId) => dispatch(SoActions.getReturnFulfillment(orderId)),
  createRefund: (payload, callback) => dispatch(SoActions.createRefund(payload, callback)),
});


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RefundForm));
